import { render } from "./CpfCnpjModal.vue?vue&type=template&id=1bebbaba&scoped=true"
import script from "./CpfCnpjModal.vue?vue&type=script&lang=js"
export * from "./CpfCnpjModal.vue?vue&type=script&lang=js"

import "./CpfCnpjModal.vue?vue&type=style&index=0&id=1bebbaba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bebbaba"]])

export default __exports__